module.exports = "/_next/static/images/01_1749w-a1857707044ff6689f9d7b97c0c6744c.png.webp";